import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const Product = () => {
  const [products, setProducts] = useState([]);
  const [sortBy, setSortBy] = useState("title-ascending");
  const [sortedProducts, setSortedProducts] = useState([]);
  const [activeView, setActiveView] = useState("grid");
  const [searchQuery, setSearchQuery] = useState("");
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const fetchProducts = () => {
    axios
      .post(`${BASE_URL}/api/category/get`)
      .then((response) => {
        if (response.data.category.length > 0) {
          setProducts(response.data.category); // Store product data
          const sorted = [...response.data.category].sort((a, b) =>
            a.name.localeCompare(b.name),
          );
          setSortedProducts(sorted);
        }
      })
      .catch((err) => { });
  };
  useEffect(() => {
    fetchProducts();
  }, []);

  const handleSortChange = (e) => {
    const value = e.target.value;
    setSortBy(value);
    let sorted = [...products];
    switch (sortBy) {
      case "title-descending":
        sorted.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "title-ascending":
        sorted.sort((a, b) => b.name.localeCompare(a.name));
        break;
      default:
        break;
    }
    setSortedProducts(sorted);
  };

  return (
    <main className="main-content site-wrapper-reveal">
      {/* <!--== Start Page Title Area ==--> */}
      <section
        className="page-content-area "
        data-bg-img="assets/img/photos/bg-page-title.webp"
        style={{
          backgroundImage: `url("../../assets/img/b1.png")`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-title-content text-center">
                <h1 className="title">Product Categories</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="product-area featured-product-area"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="container">
          {/* ---------- Section Title ---------- */}
          <div className="row">
            <div className="col-lg-8 m-auto text-center">
              <div className="section-title">
                <h2 className="title">Product Categories</h2>
                <div className="title-separator"></div>
              </div>
            </div>
          </div>
          {/* ---------- Topbar (View + Sorting) ---------- */}
          <div className="row">
            <div className="col-12">
              <div className="shop-topbar-wrapper">
                <div className="collection-shorting">
                  <div className="shop-topbar-left">
                    <div className="view-mode">
                      <nav>
                        <div
                          className="nav nav-tabs"
                          id="nav-tab"
                          role="tablist"
                        >
                          <button
                            className={`nav-link ${activeView === "grid" ? "active" : ""
                              }`}
                            id="nav-grid-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#nav-grid"
                            type="button"
                            role="tab"
                            aria-controls="nav-grid"
                            onClick={() => setActiveView("grid")}
                          >
                            <i className="fa fa-th"></i>
                          </button>
                          <button
                            className={`nav-link ${activeView === "list" ? "active" : ""
                              }`}
                            id="nav-list-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#nav-list"
                            type="button"
                            role="tab"
                            aria-controls="nav-list"
                            onClick={() => setActiveView("list")}
                          >
                            <i className="fa fa-list-ul"></i>
                          </button>
                        </div>
                      </nav>
                    </div>
                    <p>
                      Showing - {filteredProducts.length} of {products.length}{" "}
                      result
                    </p>
                  </div>

                  <div className="product-sorting-wrapper">
                    <div className="product-search">
                      <input
                        type="text"
                        className="form-control"
                        id="SearchProducts"
                        placeholder="Search products..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ---------- Product View Section ---------- */}
          <div className="tab-content mt-4">
            {activeView === "grid" ? (
              // GRID VIEW
              <div className="row">
                {filteredProducts.map((element) => (
                  // col-md-6 col-xl-4 mb-4
                  <div
                    className="col-12 col-md-6 col-xl-4 mb-4"
                    key={element.id}
                  >
                    <div className="product-item">
                      <div className="product-thumb">
                       {/* // Inside Product.js -> LIST VIEW loop, update your Links to match Grid view: */}
                        <Link to={`/product_by_category/${element.id}`}>
                          <img src={`${BASE_URL}/${element.image}`} alt={element.name} className="product-img" />
                        </Link>
                      </div>
                      <div className="product-info text-center mt-2">
                        <h4 className="sub_title mb-1">
                          <Link to={`/product_by_category/${element.id}`}>
                            {element.name}
                          </Link>
                        </h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              // LIST VIEW
              <div className="list-view">
                {filteredProducts.map((element) => (
                  <div
                    className="product-item d-flex align-items-center border p-3 mb-3"
                    key={element.id}
                  >
                    <div
                      className="product-thumb"
                      style={{ width: "280px", marginRight: "5rem" }}
                    >
                   {/* Inside Product.js  LIST VIEW loop, update your Links to match Grid view: */}
                      <Link to={`/product_by_category/${element.id}`}>
                        <img src={`${BASE_URL}/${element.image}`} alt={element.name} className="product-img" />
                      </Link>
                    </div>
                    <div className="product-info">
                      <h5 className="title mb-2">
                        <Link
                          to={`/product_images/${element.id}/${element.name}`}
                        >
                          {element.name}
                        </Link>
                      </h5>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
    </main>
  );
};
export default Product;
